import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';

export function detailsSwiper() {
  Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);

  const swiper = new Swiper('.swiper', {
    slidesPerView: 'auto',
    spaceBetween: 200,
    loop: true,

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    mousewheel: {
      forceToAxis: true,
      invert: false,
    },
  });
}
